<template>
  <div>
    <t-modal-table-content ref="addContentModalRef">
      <div class="p-2 bg-white rounded-lg">
        
        <!-- Header -->
        <div class="mb-4">
          <h2 class="text-xl font-bold text-gray-800">Curated Content</h2>
        </div>

        <div v-show="!isValidateItems" class="relative flex flex-col w-96 mb-4">
          <div class="relative w-full">
            <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"></i>
            <input 
              placeholder="Search by Book Name or Content ID" 
              class="hide-native-search p-2.5 pl-10 pr-10 w-full text-sm border rounded-lg focus:ring-blue-500 focus:border-blue-500"
              type="search" 
              v-model="searchQuery" 
              @input="onSearch" 
              @keyup.enter="onSearch" 
            />
            <i v-if="searchQuery" @click="clearSearch" class="fa-solid fa-xmark text-gray-400 text-base absolute top-3 right-3 cursor-pointer hover:text-gray-600"></i>
          </div>
          
          <div class="text-sm space-x-3 mt-3 font-medium flex justify-start items-center">
            <div>{{ selectedItems.length }} item(s) selected</div>
            <Button v-if="selectedItems.length > 0" @click="selectedItems = []" variant="outlined" color="alternative" size="xs">
              Clear
            </Button>
          </div>
        </div>

        <div v-if="isValidateItems">

<div class="relative w-96 mb-4">
  <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"></i>
  
  <input 
    placeholder="Search book name, type, or reason..." 
    class="hide-native-search p-2.5 pl-10 pr-10 w-full text-sm border rounded-lg focus:ring-blue-500 focus:border-blue-500"
    type="search" 
    v-model="searchValidationQuery"
    @input="filterValidationSearch"
  />
  
 
  <i 
    v-if="searchValidationQuery" 
    @click="clearValidationSearch" 
    class="fa-solid fa-xmark text-gray-400 text-base absolute top-3 right-3 cursor-pointer hover:text-gray-600"
  ></i>
</div>

             <div v-if="!dataItems.is_valid" class="bg-orange-50 p-2.5 rounded-lg mb-4 text-yellow-800  border-orange-200">
            <label class="text-base font-semibold mb-1 flex items-center">
              <i class="fa-solid fa-circle-info mr-2"></i> Confirmation Content
            </label>
            <p class="text-sm mb-0">Please review the content for the Onsite feature again. If there are any errors, you won't be able to save it. Make sure to correct them first.</p>
          </div>
          
          <div class="overflow-x-auto border rounded-lg height-custom overflow-y-auto">
            <table class="min-w-full bg-white text-sm text-left">
              <thead class="bg-gray-50 border-b sticky top-0 z-10">
                <tr>
                  <th class="px-6 py-3 font-semibold text-gray-500 uppercase">Image</th>
                  <th class="px-6 py-3 font-semibold text-gray-500 uppercase">Book name</th>
                  <th class="px-6 py-3 font-semibold text-gray-500 uppercase">Type</th>
                  <th class="px-6 py-3 font-semibold text-gray-500 uppercase">Status</th>
                  <th class="px-6 py-3 font-semibold text-gray-500 uppercase">Reason</th>
                </tr>
              </thead>
              
               <tbody class="divide-y divide-gray-200">
              <tr v-for="(item, index) in dataItems.data" :key="index" class="hover:bg-gray-50">
                <td class="px-6 py-1 whitespace-nowrap text-sm text-gray-500">
                    <img v-if="item.thumb_image_normal" class="h-10 w-10 object-cover rounded-none " :src="'https://ebooks.gramedia.com/ebook-covers/' + removeBucket(item.thumb_image_normal)" >
              
                  <img v-else :src="DefaultImage" class="h-10 w-10 object-cover rounded-none" alt="empty thumb" />
                </td>
                <td class="px-6 py-1 whitespace-nowrap text-sm text-gray-700">
                  {{ item.name || '-' }}
                  <p>ID: {{item.id}}</p>
                </td>
                <td class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize">{{ item.type || '-' }}</td>
                 <td class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize">
                  <span class="py-1 font-normal rounded-lg text-xs px-1.5" :class="item.is_valid ?'bg-blue-100 text-blue-800':'bg-red-100 text-red-800'">
                    {{item.is_valid ? 'Passed' : 'Failed'}}
                  </span>
                 </td>
                <td class="px-6 py-1  w-full align-middle whitespace-normal text-sm text-gray-500 capitalize max-w-xs">
  <p class="text-sm break-words mb-0">
      {{ item.message || '' }}
  </p>
</td>
              </tr>
             <tr v-if="!dataItems.data || dataItems.data.length === 0">
  <td colspan="5" class="px-6 py-6 text-center text-sm text-gray-500">
    No data matches your search.
  </td>
</tr>
            </tbody>
            </table>
          </div>
        </div>

      

        <div v-else>
          <div class="rounded-xl overflow-y-auto height-custom mb-4 border relative">
            
            
            <table class="w-full text-sm text-left text-gray-500">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th scope="col" class="p-3 w-4"></th>
                  <th scope="col" class="px-6 py-3">No</th>
                  <th scope="col" class="px-6 py-3">Image</th>
                  <th scope="col" class="px-6 py-3">Book Name</th>
                  <th scope="col" class="px-6 py-3">Type</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">
                   <tr v-if="isLoadingAvailableItems" class=" inset-0 bg-white flex justify-center items-center z-10">
                    <td colspan="5" class="px-6 py-8 h-screen text-center text-gray-500">
                     <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
                  </td>
           
    </tr>
                <tr v-for="(item, index) in availableItems" :key="`${item.id}-${index}`" class="bg-white hover:bg-gray-50">
                  <td class="p-3 w-4">
                    <input 
                      type="checkbox" 
                      :value="item.id" 
                      v-model="selectedItems"
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                    >
                  </td>
                  <td class="px-6 py-2 font-medium text-gray-900">
                    {{ (currentPage - 1) * limit + index + 1 }}
                  </td>
                  <td class="px-6 py-2">
                    <img v-if="item.thumb_image_normal" :src="'https://ebooks.gramedia.com/ebook-covers/' + removeBucket(item.thumb_image_normal)" class="h-10 w-10 object-cover border" alt="thumb" />
                    <img v-else :src="DefaultImage" class="h-10 w-10 object-cover border opacity-50" alt="empty thumb" />
                  </td>
                  <td class="px-6 py-2 text-xs font-medium">{{ item.name }}</td>
                  <td class="px-6 py-2 capitalize">{{ item.item_type || item.type }}</td>
                </tr>
                <tr v-if="availableItems.length === 0 && !isLoadingAvailableItems">
                  <td colspan="5" class="px-6 py-8 text-center text-gray-500">
                 No data available.
                  </td>
                </tr>
               
              </tbody>
            </table>
          </div> 
          
        <div v-if="totalAvailableItems / limit > 1"
        class="flex bg-white items-start justify-between ml-0 pt-0 align-middle px-0">
        <div class="font-semibold mt-1">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ limit }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalAvailableItems) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalAvailableItems)" :per-page="limit" v-model="currentPage" class="rounded-lg" />
        </div>
      </div>
        </div>
          
        <div class="flex justify-start items-start space-x-3 align-middle">
          
          <template v-if="!isValidateItems">
            <Button @click="onSelectionChange"
           :disabled="selectedItems.length === 0 || selectedItems.length > 100"
              size="sm" class="disabled:opacity-50">
              Next
            </Button>
            <Button @click="$refs.addContentModalRef.hide()" variant="outlined" color="alternative" size="sm">
              Back
            </Button>
          </template>

          <template v-else>
            
             <div  v-if="dataItems.is_valid" class="space-y-5 space-x-3">
               <Button @click="submitSelectedItems" size="sm" class="disabled:opacity-50">
              Save
            </Button>
            <Button @click="backToUpload" variant="outlined" color="alternative" size="sm">
             Back
            </Button>
             </div>
             <div v-else>
            <Button class="mt-4 text-gray-700" @click="backToUpload" variant="outlined" color="alternative" size="xs">
          Back to Choose Again
        </Button>
           </div>
          </template>

        </div>

      </div>
    </t-modal-table-content>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DefaultImage from '../../assets/img/emptyitem.png';
import Button from '@/components/ui/Button';
import { EventBus } from '../../event-bus.js';

export default {
  name: 'AddContentModal',
  components: {
    Button,
  },
  data() {
    return {
      DefaultImage: DefaultImage,
      searchQuery: '',
      searchValidationQuery:'',
      isValidateItems: false,
      originalValidationData: [],
      currentPage: 1,
      limit: 10,
      dataItems:[],
      searchTimeout: null,
      selectedItems: [],
    };
  },
  
  computed: {
    ...mapState('smartpin', {
      availableItems: state => state.availableItems,
      totalAvailableItems: state => state.totalAvailableItems,
      isLoadingAvailableItems: state => state.isLoadingAvailableItems,
    }),
  },
  
  watch: {
    currentPage() {
      this.loadTableData();
    },
  },
  
  methods: {
    ...mapActions('smartpin', ['fetchAvailableItems', 'addItemLocation', 'validateLocationItems','getLocationById']),

    openModal() {
      this.resetState();
      this.$refs.addContentModalRef.show();
      this.loadTableData();
    },

    resetState() {
      this.searchQuery = '';
      this.searchValidationQuery = '';
      this.currentPage = 1;
      this.selectedItems = []; 
      this.isValidateItems = false;
      this.dataItems = [];
      this.originalValidationData = [];
    },

    async loadTableData() {
      try {
        await this.fetchAvailableItems({
          location_id: this.$route.params.id,
          q: this.searchQuery,
          limit: this.limit,
          page: this.currentPage
        });
      } catch (error) {
        console.error("Gagal load table available items:", error);
      }
    },

    onSearch(event) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (event && event.key === 'Enter') {
        this.currentPage = 1;
        this.loadTableData();
        return;
      }
      
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadTableData();
      }, 800);
    },
 removeBucket(str) {
      if (str && str.substring(0, 6) == "images") {
        return str.substring(9);
      } else {
        return str ?? 'default.png';
      }
    },
    clearSearch() {
      this.searchQuery = '';
      this.currentPage = 1;
      this.loadTableData();
    },
    filteredValidatedItems() {
      if (!this.dataItems || !this.dataItems.data) return [];
      
      if (!this.searchValidationQuery) {
        return this.dataItems.data;
      }
      
      const query = this.searchValidationQuery.toLowerCase();
      return this.dataItems.data.filter(item => {
        const name = (item.name || '').toLowerCase();
        const type = (item.type || '').toLowerCase();
        const reason = (item.message || '').toLowerCase();
        
        return name.includes(query) || type.includes(query) || reason.includes(query);
      });
    },
    async onSelectionChange() {
      if (this.selectedItems.length === 0) return; 
      
      this.isValidateItems = true;
      const payload = { item_ids: this.selectedItems };

      try {
        const response = await this.validateLocationItems(payload);
        this.processValidationResult(response);
      } catch (error) {
         if (error && error.data && Array.isArray(error.data)) {
          console.log("Memproses JSON error dari Backend...");
          this.processValidationResult(error);
        }
      }
    },
  async fetchDetailData(id) {
      this.isLoading = true;
      this.isError = false;
    
      try {
        const response = await this.getLocationById(id);
        this.locationDetail = response.data; 
        this.progressLimit = this.locationDetail.reading_progress
      } catch (error) {
        this.isError = true;
        console.error("Gagal merender detail:", error);
      } finally {
        this.isLoading = false;
      }
    },
    processValidationResult(result) {
      if (result && typeof result === 'object') {
         this.dataItems = result; 
         if (result.data && Array.isArray(result.data)) {
          this.originalValidationData = [...result.data];
        } else {
          this.originalValidationData = [];
        }
      } else {
        console.error("Format respons tidak sesuai:", result);
     
       this.originalValidationData = result;
      }
    },
 filterValidationSearch() {
   
      if (!this.searchValidationQuery) {
        this.dataItems.data = [...this.originalValidationData];
        return;
      }
      const query = this.searchValidationQuery.toLowerCase();

      this.dataItems.data = this.originalValidationData.filter(item => {
        const name = (item.name || '').toLowerCase();
        const id = String(item.id || '').toLowerCase();
        return name.includes(query) || id.includes(query);
      });
    },
    clearValidationSearch() {
      this.searchValidationQuery = '';
      this.filterValidationSearch();
    },
    backToUpload() {
      this.isValidateItems = false;
      this.loadTableData();
    },

    async submitSelectedItems() {
      const payload = {
        id: this.$route.params.id,
        type: "add",
        item_ids: this.selectedItems
      };

      try {
        await this.addItemLocation(payload);
        
        this.$refs.addContentModalRef.hide();
        EventBus.$emit('show-toast', {
          message: 'Content has been successfully saved.',
          type: 'success'
        });
         const locationId = this.$route.params.id; 
    if (locationId) {
      this.fetchDetailData(locationId);
    }
        this.$emit('on-save-success');
        this.resetState();
      } catch (error) {
        console.error("Gagal saat mencoba saveItem:", error);
        EventBus.$emit('show-toast', {
          message: 'Failed to save content.',
          type: 'error'
        });
      }
    }
  }
}
</script>

<style scoped>
.hide-native-search::-webkit-search-cancel-button {
  -webkit-appearance: none;
  display: none;
}
.height-custom {
  max-height: 500px;
}
</style>